import { motion } from "framer-motion";
import { Lock, ShieldCheck } from "lucide-react";

const items = [
  { icon: Lock, title: "Encrypted Wallets", desc: "All wallet addresses and keys are secured with military-grade encryption." },
  { icon: ShieldCheck, title: "Secure Transactions", desc: "Every transaction is verified and processed through secure blockchain protocols." },
];

const SecuritySection = () => {
  return (
    <section id="security" className="py-24 bg-card/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">Security</h2>
          <p className="mt-4 text-muted-foreground font-body">Your assets are protected at every level.</p>
        </motion.div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-2 max-w-2xl mx-auto">
          {items.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="rounded-xl border border-gold-dark/20 bg-card p-6 text-center transition-all hover:border-gold/40"
            >
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gold/10">
                <item.icon className="h-6 w-6 text-gold" />
              </div>
              <h3 className="mt-4 font-display text-sm font-semibold text-foreground">{item.title}</h3>
              <p className="mt-2 text-xs text-muted-foreground font-body">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
